module.exports = __webpack_public_path__ + "img/IT0000300564369.e1c775c6.png";